<template>
    <div class="banner">
        <swiper class="bannerList" :navigation='{"prevEl": ".sliderPrev-btn", "nextEl": ".sliderNext-btn" }' :pagination='{"clickable": true  }'
            :slidesPerView="1.9" :spaceBetween="15" :breakpoints="swiperOptions.breakpoints">
            <swiper-slide>
                <img src="../../assets/images/banner.webp" alt="">
            </swiper-slide>
            <swiper-slide>
                <img src="../../assets/images/banner.webp" alt="">
            </swiper-slide>
            <swiper-slide>
                <img src="../../assets/images/banner.webp" alt="">
            </swiper-slide>
            <swiper-slide>
                <img src="../../assets/images/banner.webp" alt="">
            </swiper-slide>
            <div class="flex nav" >
            <div class="sliderPrev-btn"><i class="fas fa-arrow-left"></i></div>
             <div class="sliderNext-btn"><i class="fas fa-arrow-right"></i></div>
             </div>
        </swiper>
    </div>
    <div class="event mt-2 flex justify-content-between mb-2">
        <div class="title-event">
            <h1 class="mb-1"><span class="text-blue">Event</span> <span class="text-red">Berlangsung</span></h1>
            <div class="text-dim">Sebagai wujud komitmen untuk terus memberikan benefit bagi Member Partai Perindo.</div>
        </div>
        <div class="text-italic text-bold">Lihat Lainnya</div>
    </div>
    <slider />
</template>

<script>
import swiper from '../../mixins/swiper.js'
import slider from '../../components/cardSlider.vue'
export default {
  mixins: [swiper],
  components: {
    slider
  },
  data () {
    return {
      swiperOptions: {
        breakpoints: {
          250: {
            slidesPerView: 1.3,
            spaceBetween: 15
          },
          // when window width is >= 480px
          500: {
            slidesPerView: 1.7,
            spaceBetween: 15
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .banner {
        .nav{
            margin: 1rem;
            .sliderPrev-btn, .sliderNext-btn{
                cursor: pointer;
                padding: 3px 7px;
                background-color: $red;
                margin-right: 1rem;
                color: #fff;
                border-radius: 50%;
                i{
                    vertical-align: text-bottom;
                }
                &.swiper-button-disabled{
                    background-color: #ccc;
                }
            }
        }
    }
    .event{
        align-items: center;
    }
</style>
<style lang="scss">
    .swiper-container.bannerList {
        // padding-bottom: 4rem;

        .swiper-pagination {
            text-align: right !important;

            .swiper-pagination-bullet {
                width: 50px;
                border-radius: 5px;
                height: 2px;
                &.swiper-pagination-bullet-active {
                    background: $red;
                }
            }
            &.swiper-pagination-bullets{
                bottom: 18px;
                left: -1rem;
            }
        }
    }
</style>
